import { useEffect } from "react";
import { useAppBrandInfo, DEFAULT_BRAND_INFO } from "../hooks/useAppBrandInfo";

export default function BrandMetadataSync() {
  const { brandInfo } = useAppBrandInfo();
  useEffect(() => {
    document.title = `${brandInfo.product_name} | ${brandInfo.app_name}`;
    let icon = document.querySelector("link[rel~='icon']");
    if (!icon) {
      icon = document.createElement("link");
      icon.rel = "icon";
      document.head.appendChild(icon);
    }
    icon.removeAttribute("type");
    icon.href = brandInfo.fav_icon_url;
    icon.onerror = () => {
      icon.onerror = null;
      icon.href = DEFAULT_BRAND_INFO.fav_icon_url;
    };
    let description = document.querySelector("meta[name='description']");
    if (!description) {
      description = document.createElement("meta");
      description.name = "description";
      document.head.appendChild(description);
    }
    description.content = brandInfo.product_description;
    return () => { icon.onerror = null; };
  }, [brandInfo]);
  return null;
}
